
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function relatedItemsRT () {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                return _createElement('li', {}, _createElement('product-card', { 'class': 'card card--product h-full card--product-compare relative flex card--product-contained' }, _createElement('div', { 'className': 'card__media relative' }, _createElement('a', {
                    'href': this.url,
                    'aria-label': this.removeHTML(this.title),
                    'className': 'media block relative image-blend js-prod-link',
                    'tabIndex': '-1'
                }, _createElement('img', {
                    'className': 'img-fit card__main-image no-js-hidden',
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'data-media-id': this.id,
                    'loading': 'lazy',
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError
                })), _createElement('div', { 'className': 'product-label-container absolute top-0 start' }, this.out_of_stock ? _createElement('div', {
                    'className': 'product-label-wrapper flex',
                    'key': '604'
                }, _createElement('span', { 'className': 'product-label product-label--sold-out' }, 'Sold out')) : null, this.on_sale ? _createElement('div', {
                    'className': 'product-label-wrapper flex',
                    'key': '772'
                }, _createElement('span', { 'className': 'product-label product-label--sale' }, 'Sale')) : null)), this.wheel_mpn ? _createElement('button', {
                    'className': 'btn btn--primary w-full cm_view-on-vehicle-btn',
                    'onClick': () => window.Convermax.openVisualizationDialog(this.wheel_mpn),
                    'key': '947'
                }, '\n      View On Vehicle\n    ') : null, _createElement('div', { 'className': 'card__info-container flex flex-col flex-auto relative' }, _createElement('div', { 'className': 'card__info w-full' }, _createElement('div', { 'className': 'card__info-inner inline-block w-full' }, this.vendor ? _createElement('p', mergeProps({
                    'className': 'card__vendor mb-1 text-sm text-theme-light',
                    'key': '1327'
                }, { dangerouslySetInnerHTML: { __html: this.vendor } })) : null, _createElement('p', { 'className': 'card__title font-bold mb-1' }, _createElement('a', mergeProps({
                    'href': this.url,
                    'className': 'card-link text-current js-prod-link'
                }, { dangerouslySetInnerHTML: { __html: this.title } }))), this.inventory_quantity >= 8 ? _createElement('div', {
                    'className': 'badge-stock-in',
                    'key': '1677'
                }, _createElement('span', { 'className': 'badge-stock-dot' }), ' In stock\n          ') : null, this.inventory_quantity < 8 ? _createElement('div', {
                    'className': 'badge-stock-warning',
                    'key': '1826'
                }, _createElement('span', { 'className': 'badge-stock-dot' }), ' Very low stock (', this.inventory_quantity, ' units)\n          ') : null, this.out_of_stock ? _createElement('div', {
                    'className': 'badge-stock-out',
                    'key': '2019'
                }, _createElement('span', { 'className': 'badge-stock-dot' }), ' Out of Stock\n          ') : null, _createElement('div', { 'className': 'price' }, _createElement('div', { 'className': 'price__default' }, this.price_varies ? _createElement('span', { 'key': '2234' }, 'From: ') : null, _createElement('strong', { 'className': 'price__current' }, this.formatPrice(this.price)), this.on_sale ? _createElement('s', {
                    'className': 'price__was',
                    'key': '2379'
                }, this.formatPrice(this.compare_at_price)) : null, this.set_qty && !this.price_varies ? _createElement('div', {
                    'className': 'price-item--set',
                    'key': '2482'
                }, '\n                Set of ', this.set_qty, ': ', this.formatPrice(this.price * this.set_qty), '\n              ') : null))))), this.price ? _createElement('p', {
                    'className': 'affirm-as-low-as',
                    'data-amount': this.price * 100,
                    'data-affirm-type': 'logo',
                    'data-affirm-color': 'blue',
                    'key': '2748'
                }) : null));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'h4 mt-10 cm_related-products-title' }, 'You might also like...')), _createElement.apply(this, [
        'ul',
        { 'className': 'slider slider__grid grid grid-flow-col auto-cols-2 small-cards-mobile md:auto-cols-3 lg:auto-cols-4 xl:auto-cols-5 small-cards-desktop gap-x-theme gap-y-8 cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []